export const PANEL_TYPE = {
  ACCEPT: "ACCEPT",
  CLOSE: "CLOSE",
  EDIT: "EDIT",
  REACTIVATE: "REACTIVATE",
  REMOVE: "REMOVE",
};

export const MESURE_TYPE = {
  CLOSED: "Mesure clôturée",
  IN_PROGRESS: "Mesure en cours",
  WAITING: "Mesure en attente",
};
